module.exports = __webpack_public_path__ + "8ad981eb.png";